export const decodeNumberInput = (input: string): number | null => {
  const trimmed = input.trim();

  if (!trimmed) {
    return null;
  }

  const num = Number(trimmed);

  return Number.isFinite(num) ? num : null;
};
